import _ from 'lodash';
import { ItemManager } from 'spark-core-dx/managers'
import { ItemServiceFactory } from '../../services/ItemServiceFactory';

class ReportManager extends ItemManager {
    constructor(coreContext, coreState, isWarning) {
        super("Report", coreContext, coreState, isWarning);
    }

    async getPBIToken(reportId){
        
        return this._itemService.getCustom(reportId, "pbiToken").then((r) => {
            return r?.first();
        });
    }
}

export default ReportManager;